export default __webpack_public_path__ + "static/media/EM1330.34I-36205_-21510_0.a4040dcf.jpg";